var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTennisBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 16C123.451 16 16 123.453 16 256S123.451 496 256 496S496 388.547 496 256S388.549 16 256 16ZM229.121 66.105C217.416 150.852 150.852 217.41 66.107 229.117C78.008 144.773 144.775 78.008 229.121 66.105ZM65.379 278.133C177.525 266.289 266.295 177.523 278.137 65.383C366.328 75.566 436.436 145.676 446.621 233.867C334.475 245.711 245.705 334.477 233.863 446.617C145.672 436.434 75.564 366.324 65.379 278.133ZM282.879 445.895C294.584 361.148 361.148 294.59 445.893 282.883C433.992 367.227 367.225 433.992 282.879 445.895Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisBall);
export default __webpack_public_path__ + "static/media/tennis-ball.05b07150abe73410559580a005bada2d.svg";
export { ForwardRef as ReactComponent };